// src/components/placeholders/CusotmLoader.tsx
import React from "react";
import { Center, Spinner } from "@chakra-ui/react";

const CustomLoader: React.FC = () => {
  return (
    <Center
      minH={{ base: "70vh", md: "60vh", lg: "55vh" }}
      alignItems="center"
      w="full"
    >
      <Spinner size="lg" />
    </Center>
  );
};

export default CustomLoader;
